<template>
    <div class="accessIndex">
      <!--  -->
      <p class="dashboard__general--title">Información general</p>
      <div class="dashboard__options">
            <app-date-picker
              @filterQuery="getBookingsStatistics(true, false, $event)"></app-date-picker>
            <div
              class="dashboard__options--reload"
              @click="getBookingsStatistics(true, true)">
              <img src="@/assets/img/icons/refresh-icon.svg" alt="">
            </div>
          </div>
      <section class="dashboard__general">

          <div class="dashboard__general--access_container">
            <div>
              <img src="./../../../assets/bar-chart.svg" width="50" height="50">
              <br>
              <p >{{totalBookings}}</p>
              <span>Agendamientos</span>
            </div>
          </div>
          <div class="dashboard__general--access_container">
            <div>
              <img src="./../../../assets/bar-chart.svg" width="50" height="50">
              <br>
              <p >{{cancelledBookings}}</p>
              <span>Cancelados</span>
            </div>
          </div>
          <div class="dashboard__general--access_container">
            <div>
              <img src="./../../../assets/bar-chart.svg" width="50" height="50">
              <br>
              <p >{{completedBookings}}</p>
              <span>Completados</span>
            </div>
          </div>
          <div class="dashboard__general--access_container">
            <div>
              <img src="./../../../assets/bar-chart.svg" width="50" height="50">
              <br>
              <p>{{activeBookings}}</p>
              <span>Activos</span>
            </div>
          </div>
          <div class="dashboard__general--access_container">
            <div>
              <img src="./../../../assets/bar-chart.svg" width="50" height="50">
              <br>
              <p >{{unusedBookings}}</p>
              <span>Agendados sin asistencia</span>
            </div>
          </div>
          <div class="dashboard__general--access_container">
            <div>
              <img src="./../../../assets/bar-chart.svg" width="50" height="50">
              <br>
              <p >{{usedBookings}}</p>
              <span>Quedaron adentro / Sin reportar</span>
            </div>
          </div>
          <div class="dashboard__general--access_container">
            <div>
              <img src="./../../../assets/bar-chart.svg" width="50" height="50">
              <br>
              <p >{{totalUsers}}</p>
              <span>Total usuarios</span>
            </div>
          </div>
          <div class="dashboard__general--access_container">
            <div>
              <img src="./../../../assets/bar-chart.svg" width="50" height="50">
              <br>
              <p >{{bookingsByUser}}</p>
              <span>Agendamientos por usuario</span>
            </div>
          </div>
        </section>
      <!--  -->
      <section class="dashboard__by_date">
        <p class="dashboard__general--title">Entradas por hora y día</p>
        <div
          class="dashboard__by_date--container"
          id="day_hour_actions">
          <div class="dashboard__access--selectors">
            <v-select
              class="selector_input__type"
              :items="users_types"
              item-text="text"
              item-value="value"
              v-model="user_access_type"
              label="Tipo de usuario"
            ></v-select>
            <v-select
              class="selector_input__location"
              :items="only_gyms"
              item-text="attributes.name"
              item-value="id"
              v-model="location_query"
              label="Locación"
            ></v-select>
          </div>
          <div class="dashboard__options">
            <app-date-picker
              @filterQuery="updateChart('day_hour_accesses', true, false, $event)"></app-date-picker>
            <div
              class="dashboard__options--reload"
              @click="day_hour_actions = false; updateChart('day_hour_accesses', true, true)">
              <img src="@/assets/img/icons/refresh-icon.svg" alt="">
            </div>
          </div>
          <apexchart
            style="overflow:visible;"
            type="heatmap"
            width="100%"
            :options="chartOptions['day_hour_accesses']"
            :series="series['day_hour_accesses']"></apexchart>
        </div>
      </section>
    </div>
</template>

<script>
export default {
  data(){
    return{
      date_available:false,
      totalBookings: '',
      cancelledBookings:'',
      completedBookings:'',
      activeBookings:'',
      unusedBookings:'',
      usedBookings:'',
      totalUsers:'',
      bookingsByUser:'',
      total_current: 0,
      current_user: [],
      locations: [],
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2:false,
      only_gyms: [],
      users_types:[{text: "Clientes",value: "clients"},{text: "Funcionarios",value: "employees"}],
      user_access_type:"clients",
      datePickerFirstClick:false,
      hasAlreadyFilter:false,
      location_query: '',
      filterSearchedDate:new Date().toISOString().substr(0, 10),
      filterSearchedDate2:new Date().toISOString().substr(0, 10),
      months:["ENE","FEB","MAR","ABR","MAY","JUN","JUL","AGO","SEP","OCT","NOV","DIC"],
      headers: [
        {text:'Locación', value: 'name'},
        {text:'Cantidad', value: 'quantity'}
      ],
      all_queries: {},
      chartOptions: {
        day_hour_accesses:{}
      },
      series: {
        day_hour_accesses:[]
      },
    }
  },
  watch: {
    user_access_type: function (val, oldVal) {
      var from_input_text = document.querySelectorAll("#day_hour_actions .dashboard__options--input p")[0].innerHTML;
      var to_input_text = document.querySelectorAll("#day_hour_actions .dashboard__options--input p")[1].innerHTML;
      var dates_graph = {date_from: '', date_to: ''}
      if (from_input_text!="Desde" && to_input_text!="Hasta") {
        dates_graph = {date_from: from_input_text, date_to: to_input_text}
      }
      this.updateChart('day_hour_accesses', false, false, dates_graph);
    }
  },
  methods:{
    generateData(hour,date_action,count,graph_info) {
      var vm = this;
      var i=0;
      var series = [];
      while (i < count) {
        var x = date_action.toISOString().split('T')[0];
        var y = 0;
        try {
          y = graph_info=='day_hour_accesses' ?
                vm.all_queries[graph_info][vm.user_access_type][x][hour] :
                vm.all_queries[graph_info][x][hour];
          if(y==undefined){
            y = 0;
          }
        }
        catch(err) {
          y = 0;
        }
        series.push({
          x: x,
          y: y
        });
        date_action.setDate(date_action.getDate() + 1);
        i++;
      }
      return series;
    },
    updateChart(graph_info, make_request, reload = false, dates) {
      var object = (dates != undefined && dates != null) ? dates : {date_from: '', date_to: ''}
      var first_date_element = object.date_from;
      var last_date_element = object.date_to;
      var firstDate = null;
      var secondDate = null;
      if(first_date_element!=null && last_date_element!=null && !reload){
        if(first_date_element =="" || last_date_element ==""){
          if(make_request==true){
            // alert("Por favor ingrese la fecha inicial y final para hacer la nueva consulta");
            this.updateAlertMessage("Por favor ingrese la fecha inicial y final para hacer la nueva consulta");
            this.updateIsInAlert(true);
            make_request = false;
          }
          secondDate = new Date();
          secondDate.setHours(23,59,59);
          firstDate = new Date();
          firstDate.setHours(0,0,0,0);
          firstDate.setMonth(secondDate.getMonth() - 1);
        }else{
          secondDate = new Date(last_date_element);
          firstDate = new Date(first_date_element);
          secondDate.setHours(23,59,59);
          // if (make_request) {
          //   secondDate.setDate(secondDate.getDate() + 1);
          // }
          firstDate.setHours(0,0,0,0);
          // if (make_request) {
          //   firstDate.setDate(firstDate.getDate() + 1);
          // }
        }
      }
      if(reload){
        var json_send={
          query_name: graph_info,
          init_date: '',
          offset_time: new Date().getTimezoneOffset(),
          finish_date: '',
          company: this.getSessionCompanyId()
        };
        if (graph_info=='day_hour_accesses') {
          json_send.location_id_date = this.location_query;
        }
        console.log("<---------------------------- Dashboard params");
        console.log(json_send);
        this.$http.post('access/query_with_dates',{
          data: this.encrypt(json_send).toString()
        },{
          headers: {
            "X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()
          }}).then(function(response){
          this.all_queries[graph_info]=response.body.data[graph_info];
          this.updateChart(graph_info, false);
          if(response.body.meta != undefined &&
             response.body.meta != null){
            if(response.body.meta.authentication_token != undefined &&
               response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined &&
               response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      }
      if(make_request && secondDate!=null && firstDate!=null && !reload){
        var json_send={
          query_name: graph_info,
          init_date: this.$moment(firstDate).format("YYYY-MM-DD"),
          offset_time: new Date().getTimezoneOffset(),
          finish_date: this.$moment(secondDate).format("YYYY-MM-DD"),
          company: this.getSessionCompanyId()
        };
        // WHEN ADD LOCATION FILTER
        if (graph_info=='day_hour_accesses') {
          json_send.location_id_date = this.location_query;
        }
        console.log("<---------------------------- Dashboard params");
        console.log(json_send);
        this.$http.post('access/query_with_dates',{
          data: this.encrypt(json_send).toString()
        },{
          headers: {
            "X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()
          }}).then(function(response){
            this.all_queries[graph_info]=response.body.data[graph_info];
            this.updateChart(graph_info, false);
            if(response.body.meta != undefined &&
              response.body.meta != null){
              if(response.body.meta.authentication_token != undefined &&
                response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
            if(graph_info == 'day_hour_accesses'){
              var vm = this
              var oneDay = 24*60*60*1000;
              get_first_time = firstDate.getTime();
              get_second_time = secondDate.getTime();
              var diffDays = Math.round(Math.abs((get_first_time - get_second_time)/(oneDay)));
              var series_array=[];
              var count_temp=0;
              for(var i = 23;i>=0;i--){
                var copiedDate = new Date(firstDate.getTime());
                var hour=i+':00';
                var series={
                  name: hour,
                  data: vm.generateData(hour,copiedDate,diffDays,graph_info)
                };
                count_temp++;
                series_array.push(series);
              }
              // vm.updateSeries(series_array, true)
              vm.series[graph_info] = series_array;
            }
          }, function(response){
            if(response.body.meta != undefined &&
             response.body.meta != null){
            if(response.body.meta.authentication_token != undefined &&
               response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
        // Hacer la petición de actualización
      }else{
        var vm = this;
        // Make sure to update the whole options config and not just a single property to allow the Vue watch catch the change.
        switch (graph_info) {
          case "day_hour_accesses":
            vm.chartOptions[graph_info]={
              chart: {
                height: 600,
                type: 'heatmap',
                toolbar:{
                  show: false
                }
              },
              xaxis: {
                labels:{
                  rotate:-90
                }
              },
              dataLabels: {
                  enabled: false
              },
              colors: ["#8966FF"]
            }
            var oneDay = 24*60*60*1000;
            var get_first_time = firstDate.getTime();
            var get_second_time = secondDate.getTime();
            var diffDays = Math.round(Math.abs((get_first_time - get_second_time)/(oneDay)));
            var series_array=[];
            var count_temp=0;
            for(var i = 23;i>=0;i--){
              var copiedDate = new Date(firstDate.getTime());
              var hour=i+':00';
              var series={
                name: hour,
                data: vm.generateData(hour,copiedDate,diffDays,graph_info)
              };
              count_temp++;
              series_array.push(series);
            }
            // vm.updateSeries(series_array, true)
            vm.series[graph_info] = series_array;
            break;
        }
      }
    },
    getChartsInfo(defaultOption){
      // var initialDate=new Date().toISOString().substr(0, 10);
      // var lastDate=new Date().toISOString().substr(0, 10);
      var initialDate= ""
      var lastDate=""
      if(!defaultOption){
        initialDate=this.filterSearchedDate;
        lastDate=this.filterSearchedDate2;
      }
      else{
        this.date= new Date().toISOString().substr(0, 10);
        this.date2= new Date().toISOString().substr(0, 10);
        this.datePickerFirstClick=false;
        this.hasAlreadyFilter=false;
      }
      try {
        var json_send={
          init_date: initialDate,
          offset_time: new Date().getTimezoneOffset(),
          finish_date: lastDate,
          company: this.getSessionCompanyId()
        };
        this.$http.get('access/summary_accesses',{
        params:{
          data: json_send
        },
        headers:
          {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()
          }
        }
      ).then(function(response){
          this.total_current=0;
          this.current_user= [];
          var vm = this;
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          this.all_queries = response.body.data.queries;
          for (var key in vm.all_queries) {
            vm.updateChart(key,false);
          }
          console.table(response.body.data);
          this.loaded = true;
          this.date_available=true;
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          // if (response.body.data.message != null &&
          //     response.body.data.message != undefined &&
          //     response.body.data.message != '' ){
          //     alert(response.body.data.message)
          // }else{
          //   alert(response.body.data)
          // }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    getBookingsStatistics(make_request, reload = false, dates){
      var object = (dates != undefined && dates != null) ? dates : {date_from: '', date_to: ''}
      var first_date_element = object.date_from;
      var last_date_element = object.date_to;
      var firstDate = null;
      var secondDate = null;
      if(first_date_element!=null && last_date_element!=null && !reload){
        if(first_date_element =="" || last_date_element ==""){
          if(make_request==true){
            // alert("Por favor ingrese la fecha inicial y final para hacer la nueva consulta");
            this.updateAlertMessage("Por favor ingrese la fecha inicial y final para hacer la nueva consulta");
            this.updateIsInAlert(true);
            make_request = false;
          }
          secondDate = new Date();
          secondDate.setHours(23,59,59);
          firstDate = new Date();
          firstDate.setHours(0,0,0,0);
          firstDate.setMonth(secondDate.getMonth() - 1);
        }else{
          secondDate = new Date(last_date_element);
          firstDate = new Date(first_date_element);
          secondDate.setHours(23,59,59);
          if (make_request) {
            secondDate.setDate(secondDate.getDate());
          }
          firstDate.setHours(0,0,0,0);
          if (make_request) {
            firstDate.setDate(firstDate.getDate());
          }
        }
      }
      if(reload){
        var json_send={
          init_date: '',
          finish_date: '',
          company: this.getSessionCompanyId()
        };
        console.log('----------> Company id in Object!!!', this.getCompany().id)
        console.log('----------> Company in new variable!!!', this.getSessionCompanyId())
        this.$http.post('access/bookings_statistics',{
          data: this.encrypt(json_send).toString()
        },{headers: {
            "X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()
          }}).then(function(response){
            this.totalBookings = response.body.data.total_bookings;
            this.cancelledBookings = response.body.data.cancelled_bookings;
            this.completedBookings = response.body.data.completed_bookings;
            this.activeBookings = response.body.data.active_bookings;
            this.unusedBookings = response.body.data.unused_bookings;
            this.usedBookings = response.body.data.used_bookings;
            this.totalUsers = response.body.data.total_users;
            this.bookingsByUser = response.body.data.bookings_by_user;
            if(response.body.meta != undefined &&
              response.body.meta != null){
              if(response.body.meta.authentication_token != undefined &&
                response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined &&
               response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      }
      if(make_request && secondDate!=null && firstDate!=null && !reload){
        var json_send={
          init_date: this.$moment(firstDate).format("YYYY-MM-DD"),
          finish_date: this.$moment(secondDate).format("YYYY-MM-DD"),
          company: this.getSessionCompanyId()
        };
        this.$http.post('access/bookings_statistics',{
          data: this.encrypt(json_send).toString()
        },{
          headers: {
            "X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()
          }}).then(function(response){
            this.totalBookings = response.body.data.total_bookings;
            this.cancelledBookings = response.body.data.cancelled_bookings;
            this.completedBookings = response.body.data.completed_bookings;
            this.activeBookings = response.body.data.active_bookings;
            this.unusedBookings = response.body.data.unused_bookings;
            this.usedBookings = response.body.data.used_bookings;
            this.totalUsers = response.body.data.total_users;
            this.bookingsByUser = response.body.data.bookings_by_user;
            if(response.body.meta != undefined &&
              response.body.meta != null){
              if(response.body.meta.authentication_token != undefined &&
                response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
        }, function(response){
          if(response.body.meta != undefined &&
             response.body.meta != null){
            if(response.body.meta.authentication_token != undefined &&
               response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      }
      //
    }
  },
  mounted(){
    this.only_gyms = [{id:'',attributes:{name:'Todas las locaciones'}}];
    this.only_gyms = this.only_gyms.concat(
                        this.getLocations().filter(function(ele){
                          return ele.attributes.location_type == "Centro Deportivo"
                        }));
    this.getChartsInfo(true);
    this.getBookingsStatistics(false, true)
    // cl current_user
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/access/Dashboard.vue